
import Vue from "vue";
import { Component } from "vue-property-decorator";
import RevisionsList from "@/components/Reusable/Revisions/RevisionsList.vue";
import { SelectorsRevision } from "@/types/revisions";
import { globalStore } from "@/store/store-accessor";
import { fetchRemoteSelectorsRevisions } from "@/lib/selectors/revisions";
import RevisionsPanel from "@/components/Settings/RevisionsPanel.vue";

@Component({
  components: { RevisionsPanel, RevisionsList }
})
export default class SelectorsPanelHistoryViewMode extends Vue {
  resourceKey: keyof SelectorsRevision = "selectors";

  get selectors() {
    return globalStore.cssSelectors;
  }

  get hasUnsavedChangesPresent() {
    return globalStore.selectorsHasUnsavedChangesPresent;
  }

  get fetchRevisionsMethod() {
    return fetchRemoteSelectorsRevisions;
  }
}
